import './ReportePorSectorView.scss'

import React, { Component } from 'react'
import { Container } from 'react-bootstrap'

import { TABLE_REPORTE_ESTADO_POR_SECTOR_UNO,
  TABLE_REPORTE_ESTADO_POR_SECTOR_DOS,
  TABLE_REPORTE_ESTADO_POR_SECTOR_TRES,
  TABLE_REPORTE_ESTADO_POR_SECTOR_CUATRO,
  TABLE_REPORTE_ESTADO_POR_SECTOR_CINCO,
  TABLE_TOTAL_ESTADO_POR_SECTOR_UNO,
  TABLE_TOTAL_ESTADO_POR_SECTOR_DOS,
  TABLE_TOTAL_ESTADO_POR_SECTOR_TRES,
  TABLE_TOTAL_ESTADO_POR_SECTOR_CUATRO,
  TABLE_TOTAL_ESTADO_POR_SECTOR_CINCO
} from '../../../config/tables'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'

class ReportePorSectorView extends Component {
  render () {
    return (
      <Container fluid>
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_SECTOR_UNO} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_SECTOR_DOS} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_SECTOR_TRES} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_SECTOR_CUATRO} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_SECTOR_CINCO} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_SECTOR_UNO} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_SECTOR_DOS} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_SECTOR_TRES} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_SECTOR_CUATRO} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_SECTOR_CINCO} />
      </Container>
    )
  }
}
export default ReportePorSectorView
